// Firebase configuration. Reads from Vite environment variables (.env.local).
// On the dancer side we mostly use REST polling (see ./rest.js) to avoid the
// 100-concurrent-websocket cap on Spark plan. On the instructor side we use
// the realtime SDK (./realtime.js) for instant updates.

import { initializeApp } from 'firebase/app'
import { getDatabase } from 'firebase/database'

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
}

const requiredKeys = ['apiKey', 'databaseURL', 'projectId', 'appId']
for (const key of requiredKeys) {
  if (!firebaseConfig[key]) {
    // eslint-disable-next-line no-console
    console.error(
      `[firebase/config] Missing VITE_FIREBASE_${key.toUpperCase()} in .env.local. ` +
      `Copy .env.example to .env.local and fill in the values.`
    )
  }
}

export const firebaseApp = initializeApp(firebaseConfig)
export const database = getDatabase(firebaseApp)
export const databaseURL = firebaseConfig.databaseURL
